import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.
    use(Backend).
    use(LanguageDetector).    
    use(initReactI18next). // passes i18n down to react-i18next
    init({
        react:{
            useSuspense: false //Avoid errors when loading languages
        },
        lng: 'es_ES',
        keySeparator: false, // we do not use keys in form messages.welcome
        fallbackLng: { 
            en_NG: ['en_NG', 'en_UK', 'en_US'], 
            en_UK: ['en_UK', 'en_US'],
            en_US: ['en_US', 'en_UK'],
            es_ES: ['es_ES', 'en_US'],
            pt_BR: ['pt_BR', 'en_US'],
            custom: ['custom'], //Support for custom properties in the translation
            default: ['es_ES']
        },
        debug: false,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n
